import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar, useIonAlert, useIonRouter, useIonViewWillEnter } from '@ionic/react';
import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useAppContext } from '../AppProvider';

import PlanCards from '../components/PlanCards';
import { getBillingAdapter } from '../components/getBillingAdapter';

const billing = getBillingAdapter();
const platform = Capacitor.getPlatform();

const Plans: React.FC = () => {
    const [rcMgtURL, setRcMgtURL] = useState<string | null>(null);

    const { networkStatus, getAppStatus, authenticateMember, authorizedMember, getAuthorizedMember, getLevels, level, settings, setShowLoader, SWFullHorizLogo, SWTextDarkLogo, textLogoLoaded, fadeInTextLogo, showToast } = useAppContext();  

    const router = useIonRouter();
    const [showAlert] = useIonAlert();        
    
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => {
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if (!authenticated || authenticated.mt == '') { router.push('/login', 'forward'); }
                else {
                    await getLevels(authenticated.mt);                
                    setShowLoader(false);
                }
            }
        };
        authenticate();
    }); 

    const handleRestorePurchases = async () => {
        try {
            setShowLoader(true);

            const customerInfo = await billing.restorePurchases?.();

            if (!customerInfo) {
                return;
            }

            const active = customerInfo.entitlements.active;
            console.log('Restored active entitlements:', Object.keys(active));

            await getAuthorizedMember(authorizedMember.memberToken);

            setShowLoader(false);

            showAlert({
                header: 'Purchases Restored',
                message: Object.keys(active).length
                    ? 'Your purchases were restored successfully.'
                    : 'No active purchases were found for this account.',
                buttons: ['OK'],
            });
        } catch (e: any) {
            setShowLoader(false);
            showAlert({
                header: 'Restore Failed',
                message: e?.message ?? 'Unable to restore purchases.',
                buttons: ['OK'],
            });
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons> 
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='PlansContent'>                
                <div className='ion-padding-bottom'>
                    <h1 className='ion-text-center'>Manage Your Membership Plan</h1>
                </div>
                <IonGrid fixed>
                    <IonRow>
                        <IonCol size='12'>
                            <IonCard className='ion-padding'>
                                <IonCardContent className='ion-padding'>
                                    <p><strong>You can upgrade and downgrade your membership plan, below.</strong></p>
                                    <p><IonText>The fundamental features of SoloWise, including unlimited* Timers and one emergency contact, are always free with our basic plan.</IonText></p>
                                    <p><IonText>Three premium plans are also available to offer more capacity for busy or complex lives. Our premium plans are perfect for people who go out and either explore or socialize alone, professionals who frequently meet new and unfamiliar clients one-on-one, or at-risk individuals living independently.</IonText></p>
                                    
                                    {rcMgtURL &&
                                      <>
                                        <p><strong>To make any other changes to your membership plan, such as updating your payment method, please go directly to the secure page provided by SoloWise's subscription management provider, RevenueCat.</strong></p>
                                        <IonButton color={'secondary'} fill='outline' href={rcMgtURL}>Go to RevenueCat</IonButton>
                                      </>
                                    }
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ion-justify-content-center ion-margin-bottom"> 
                        <PlanCards rcMgtURL={rcMgtURL} setRcMgtURL={setRcMgtURL} />
                        
                        {(platform === 'android' || platform === 'ios') &&
                        <IonButton
                            fill="clear"
                            color="medium"
                            onClick={handleRestorePurchases}
                            >
                            Restore Purchases
                        </IonButton>
                        }
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonCard>
                                <IonCardContent className='ion-padding'>
                                    <IonText>* Unused Timer Alarms do not roll-over to the following month.</IonText> 
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>                                 
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Plans;